import React from 'react';
import { NavLink } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import './lan.css';

// Servers page sub-navigation: regular servers | LAN environments (venue agents).
// Underlined tabs (NavLink's own "active" class); also loads lan.css for every LAN page.
export default function LanTabs() {
  const { t } = useTranslation();
  return (
    <nav className="lan-tabs">
      <NavLink to="/admin/servers" end className="lan-tab">{t('lan.tabServers', 'Servers')}</NavLink>
      <NavLink to="/admin/servers/lan" className="lan-tab">{t('lan.tabLan', 'LAN Environments')}</NavLink>
    </nav>
  );
}
